import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query GetStoreData(
    $organisationId: ID
    $schemeType: ID!
    $filters: FilterArgument
    $page: Int
    $productsPerPage: Int
    $orderBy: String
    $locale: String
  ) {
    storeProductsData(
      locale: $locale
      organisationId: $organisationId
      schemeType: $schemeType
      filters: $filters
      page: $page
      productsPerPage: $productsPerPage
      orderBy: $orderBy
    ) {
      employeeOrganisation {
        id
        scheme {
          id
          storeName
          benefitName
          limit
          brochureGroups {
            id
            term
          }
          store {
            totalPages
            totalEntries
            filters {
              brands
              promotions
              trendings
            }
            products {
              id
              productId
              brochureGroupId
              name
              price
              totalAmount
              url
              image
              productTagName
              productTagImage
              term
              brand
              category
              variant
              sku
              department
              supplierName
            }
            departments {
              id
              name
              count
              categories {
                id
                name
                count
                subcategories {
                  id
                  name
                  count
                }
              }
            }
            breadcrumbs {
              label
              link
            }
            algoliaQueryId
          }
        }
      }
    }
  }
`

export const getStoreProductsQueryKey = getQueryNames(query)[0]
export default query
